module.exports = __webpack_public_path__ + "static/img/result-img.3b34196.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/result-img.png
// module id = tqFJ
// module chunks = 1